
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import TeamList from 'theme/components/shared/TeamList'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "the-team"
    }}>{`The Team`}</h1>

    <h4 {...{
      "id": "a-successful-project-requires-many-people-to-play-many-roles-some-members-write-code-or-documentation-while-others-are-valuable-as-testers-submitting-patches-and-suggestions"
    }}>{`A successful project requires many people to play many roles. Some members write code or documentation, while others are valuable as testers, submitting patches and suggestions.`}</h4>
    <h4 {...{
      "id": "the-team-comprises-members-and-contributors-members-have-direct-access-to-the-source-of-a-project-and-actively-evolve-the-code-base-contributors-improve-the-project-through-submission-of-patches-and-suggestions-to-the-members-the-number-of-contributors-to-the-project-is-unbounded-get-involved-today-all-contributions-to-the-project-are-greatly-appreciated"
    }}>{`The team comprises Members and Contributors. Members have direct access to the source of a project and actively evolve the code-base. Contributors improve the project through submission of patches and suggestions to the Members. The number of Contributors to the project is unbounded. Get involved today. All contributions to the project are greatly appreciated.`}</h4>
    <h2 {...{
      "id": "members"
    }}>{`Members`}</h2>
    <h4 {...{
      "id": "the-following-is-a-list-of-developers-with-commit-privileges-that-have-directly-contributed-to-the-project-in-one-way-or-another"
    }}>{`The following is a list of developers with commit privileges that have directly contributed to the project in one way or another.`}</h4>
    <TeamList mdxType="TeamList" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;